// import Select from "react-select";
import Creatable from "react-select/creatable";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import { useEffect, useState, useContext } from "react";
import logo from "assets/images/sitelogo.svg";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { translateToReactSelect } from "utils/helperFunctions";
import toast from "react-hot-toast";
import React from "react";
import chroma from "chroma-js";
import toastFunction from "utils/toast";

import Select, { StylesConfig } from "react-select";

import sendRequest from "hooks/useAxios";
import { sendRequestHashtag } from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import { useNavigate } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { sendRequestHashtags } from "hooks/useAxios";
import Loader from "utils/Loader";
const AddProductModal = ({ product }) => {
  // const navigation = useNavigate();
  const auth = useContext(WithAuthentication);
  // product state
  const [addProduct, setAddProduct] = useState({
    title: "",
    description: "",
    tags: [],
    bodytxt: "",
    file: "",
    files: "",
    main_seller: "",
    price_from: "",
    price_to: "",
    Interest_rates: "",
    shop_commission: "",
    mainshop_commission: ""
  });

  const [mainSupplier, setMainSupplier] = useState([
    { label: "همه", value: "-1" },
    { label: "هیچکس", value: "-2" }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [hashtagsListOption, setHashtagsListOption] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    async function pageLoad() {
      await sendRequestHashtags("get_main_hashtag").then(data => {
        let temp =
          data?.data?.data?.length > 0 ? [...data?.data?.data?.reverse()] : [];
        let x = ["689", "376", "691"];
        let subgroup = [];
        for (let i = 0; i < temp.length; i++) {
          for (let a = 0; a < x.length; a++) {
            if (temp[i].hashtag.id == x[a]) {
              for (let j = 0; j < temp[i].subs.length; j++) {
                let objects = {
                  label: temp[i].subs[j].txt,
                  value: temp[i].subs[j].id
                };
                subgroup.push(objects);
              }
            }
            setHashtagsListOption(subgroup);
          }
        }
      });
      setIsLoading(false);
    }
    pageLoad();
  }, []);
  useEffect(() => {
    let x = [{ label: "همه", value: "-1" }, { label: "هیچکس", value: "-2" }];
    sendRequest("Find_businesses", {
      conditions: "status/=/0@@type/=/0"
    }).then(data => {
      setMainSupplier([
        ...mainSupplier,
        ...data.data.map(value => {
          return {
            label: value.title,
            value: value.id
          };
        })
      ]);
    });
  }, []);

  const inputChanged = e => {
    let value = removeCommas(e.target.value);
    let name = e.target.name;
    try {
      if (isNaN(value)) throw new Error("لطفا عدد را به درستی وارد نمایید.");
      setAddProduct(prev => {
        return {
          ...prev,
          [name]: +value
        };
      });
    } catch (ex) {
      toastFunction("error", ex.message);
    }
  };
  const saveData = () => {
    // console.log("x", x);
    let fd = new FormData();
    fd.append("title", addProduct.title);
    fd.append("bodytxt", addProduct.bodytxt);
    fd.append("description", addProduct.description);
    fd.append("main_seller", addProduct.main_seller.value);
    fd.append("price_from", addProduct.price_from);
    fd.append("price_to", addProduct.price_to);
    fd.append("Interest_rates", addProduct.Interest_rates);
    fd.append("shop_commission", addProduct.shop_commission);
    fd.append("mainshop_commission", addProduct.mainshop_commission);
    fd.append("addHashtag", addProduct.tags.map(v => v.value).join(","));
    fd.append("file", addProduct.file);
    // for (let i = 0; i < addProduct.files.length; i++) {
    //   fd.append("files[]", addProduct.files[i]);
    // }
    sendRequest("addproduct", fd).then(({ data }) => {
      if (data.status == 1) {
        toastFunction("success", "محصول با موفقیت ایجاد شد.");

        // toast.success("محصول با موفقیت ایجاد شد.");
        document.querySelector("#addProductModal .btn-close").click();
        // navigation("/admin-panel/products");
        setAddProduct({
          title: "",
          description: "",
          tags: [],
          price_from: "",
          price_to: "",
          bodytxt: "",
          file: "",
          files: "",
          main_seller: "",
          Interest_rates: "",
          shop_commission: "",
          mainshop_commission: ""
        });
      } else {
        toastFunction("error", "مشکلی در افزودن محصول به وجود آمد.");
      }
    });
  };

  // list of tags

  const [tags, setTags] = useState([]);
  useEffect(() => {
    // sendRequest2("Find_hashtags").then(({ data }) => {
    sendRequestHashtag("get_sub_hashtag").then(({ data }) => {
      setTags(data.data);
      console.log("tag", tags);
    });
  }, []);
  // const tagsOptions = [];

  const tagsOptions = translateToReactSelect(tags, false);

  const [productTag, setProductTag] = useState([]);

  const [subgroup, setSubgroup] = useState([]);
  useEffect(() => {
    if (productTag.length > 0) {
      sendRequest("Find_hashtagsLinks", {
        conditions: `hashtags_links.parent_id/in/${productTag
          .map(v => v.value)
          .join(",")}`,
        tbl_name: "Inner join,hashtags,hashtag_id,id"
        // fields:"hashtags.id,hashtags.txt"
      }).then(data => {
        setSubgroup(
          data.data.map(v => {
            return {
              label: v.txt,
              value: v.hashtag_id
            };
          })
        );
      });
    }
    console.log("product tag xxx", productTag.map(v => v.value).join(";"));
  }, [productTag]);
  // validation
  const [validateStatus, setValidateStatus] = useState({
    title: false,
    cover: false,
    productTag: false,
    main_seller: false,
    price_from: false,
    price_to: false,
    Interest_rates: false,
    shop_commission: false,
    mainshop_commission: false,
    checkPrice: false
  });

  const validation = () => {
    let isValid = true;
    if (addProduct.price_to < addProduct.price_from) {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, checkPrice: true };
      });
    }
    if (addProduct.title == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, title: true };
      });
    }
    if (addProduct.file == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, cover: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, cover: false };
      });
    }
    if (addProduct.price_from == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, price_from: true };
      });
    }
    if (addProduct.price_to == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, price_to: true };
      });
    }
    if (addProduct.Interest_rates == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, Interest_rates: true };
      });
    }
    if (addProduct.shop_commission == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, shop_commission: true };
      });
    }
    if (addProduct.mainshop_commission == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, mainshop_commission: true };
      });
    }
    if (addProduct.main_seller == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, main_seller: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, main_seller: false };
      });
    }
    if (addProduct.tags.length <= 0) {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, productTag: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, productTag: false };
      });
    }
    return isValid;
  };

  return (
    <>
      <div className="modal" id="addProductModal" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-fullscreen-lg-down">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">تعریف محصول جدید </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form name="addProduct">
                {/* <div> */}
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="addProduct-nav-info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#addProduct-nav-info"
                      type="button"
                      role="tab"
                      aria-controls="addProduct-nav-info"
                      aria-selected="true"
                    >
                      اطلاعات اولیه
                    </button>
                    <button
                      className="nav-link"
                      id="addProduct-nav-sale-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#addProduct-nav-sale"
                      type="button"
                      role="tab"
                      aria-controls="addProduct-nav-sale"
                      aria-selected="false"
                    >
                      اطلاعات فروش
                    </button>
                    <button
                      className="nav-link"
                      id="addProduct-nav-more-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#addProduct-nav-more"
                      type="button"
                      role="tab"
                      aria-controls="addProduct-nav-more"
                      aria-selected="false"
                    >
                      اطلاعات تکمیلی
                    </button>
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                  {isLoading && <Loader />}
                  {/* محتوا اطلاعات اولیه  */}
                  <div
                    className="tab-pane fade show active"
                    id="addProduct-nav-info"
                    role="tabpanel"
                    aria-labelledby="addProduct-nav-info-tab"
                  >
                    <div className="d-flex first-container mt-3">
                      {/* عنوان */}
                      <div className="my-2 mx-1 align-items-baseline title">
                        <label for="title" className="">
                          عنوان:
                        </label>
                        <input
                          id="title"
                          className="round form-control"
                          type="text"
                          // defaultValue={product.title}
                          value={addProduct.title}
                          required
                          onChange={e => {
                            setAddProduct(prev => {
                              return { ...prev, title: e.target.value };
                            });
                          }}
                          onKeyUp={() => {
                            if (addProduct.title == "") {
                              setValidateStatus(prev => {
                                return { ...prev, title: true };
                              });
                            } else {
                              setValidateStatus(prev => {
                                return { ...prev, title: false };
                              });
                            }
                          }}
                        ></input>
                        <div
                          className={`ms-1 ${
                            validateStatus.title == true ? "d-block" : "d-none"
                          } validation-txt`}
                        >
                          فیلد عنوان نباید خالی باشد.
                        </div>
                      </div>
                      {/* کاور */}
                      <div className="my-2 mx-1 align-items-baseline other-media">
                        <label for="coverPic" className="">
                          کاور محصول:
                        </label>
                        <input
                          id="coverPic"
                          className=" form-control "
                          type="file"
                          onChange={e => {
                            setAddProduct(prev => {
                              return { ...prev, file: e.target.files[0] };
                            });
                          }}
                        ></input>

                        <div
                          className={`ms-1 ${
                            validateStatus.cover == true ? "d-block" : "d-none"
                          } validation-txt`}
                        >
                          فیلد کاور نباید خالی باشد.
                        </div>
                      </div>
                    </div>
                    <div className="d-flex my-2 mx-1 align-items-baseline ">
                      {/* گروه کالا */}
                      {/* <div className="my-2 title">
                        <label for="tags">گروه کالایی:</label>
                      
                        <Select
                          id="tags"
                          options={tagsOptions}
                          isMulti={true}
                          className="mx-1"
                          
                          onChange={e => {
                            setProductTag(e);
                            console.log("product tag :", productTag);
                          }}
                        />
                      </div> */}

                      {/* زیرگروه کالا */}
                      {auth.userInfo.userType == 0 && (
                        <div className="my-2 title">
                          <label for="tags">زیرگروه کالایی:</label>
                          {/* <Creatable */}
                          <Select
                            id="tags"
                            options={tagsOptions}
                            isMulti={true}
                            className="mx-1"
                            value={addProduct.tags}
                            onChange={e => {
                              setProductTag(e);
                              setAddProduct(prev => {
                                return {
                                  ...prev,
                                  // tags: addProduct.tags?.push(e.value?.join(","))
                                  tags: e
                                };
                              });
                            }}
                          />
                          <div
                            className={`ms-1 ${
                              validateStatus.productTag == true
                                ? "d-block"
                                : "d-none"
                            } validation-txt`}
                          >
                            فیلد زیرگروه کالایی نباید خالی باشد.
                          </div>
                        </div>
                      )}
                      {auth.userInfo.userType == 3 && (
                        <div className="my-2 title">
                          <label for="tags">زیرگروه کالایی:</label>
                          {/* <Creatable */}
                          <Select
                            id="tags"
                            options={hashtagsListOption}
                            isMulti={true}
                            className="mx-1"
                            value={addProduct.tags}
                            onChange={e => {
                              setProductTag(e);
                              setAddProduct(prev => {
                                return {
                                  ...prev,
                                  // tags: addProduct.tags?.push(e.value?.join(","))
                                  tags: e
                                };
                              });
                            }}
                          />
                          <div
                            className={`ms-1 ${
                              validateStatus.productTag == true
                                ? "d-block"
                                : "d-none"
                            } validation-txt`}
                          >
                            فیلد زیرگروه کالایی نباید خالی باشد.
                          </div>
                        </div>
                      )}
                      <div className="my-2 mx-1 title align-items-baseline">
                        <div>
                          <label htmlFor="addSupplier">
                            انتخاب تامین کننده :
                          </label>
                          <Select
                            id="addSupplier"
                            options={mainSupplier}
                            value={addProduct.main_seller}
                            onChange={e => {
                              setAddProduct(prev => {
                                return { ...prev, main_seller: e };
                              });
                              console.log(addProduct);
                            }}
                          />
                          <div
                            className={`ms-1 ${
                              validateStatus.main_seller == true
                                ? "d-block"
                                : "d-none"
                            } validation-txt`}
                          >
                            فیلد تامین کننده نباید خالی باشد.
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* توضیحات */}
                    <div className="my-2 align-items-baseline">
                      <label for="txt" className="">
                        توضیحات:{" "}
                      </label>
                      <textarea
                        id="txt"
                        className=" form-control"
                        value={addProduct.description}
                        onChange={e => {
                          setAddProduct(prev => {
                            return { ...prev, description: e.target.value };
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="d-flex second-container">
                      {/* فایلهای جانبی */}
                      {/* <div className="my-2 mx-1 align-items-baseline cover ">
                        <label for="otherMedia">فایلهای جانبی:</label>
                        <input
                          className="form-control"
                          id="otherMedia"
                          type="file"
                          multiple
                          onChange={e => {
                            setAddProduct(prev => {
                              return { ...prev, files: e.target.files };
                            });
                          }}
                        ></input>
                      </div> */}
                    </div>
                  </div>

                  {/* محتوا اطلاعات فروش */}
                  <div
                    className="tab-pane fade "
                    id="addProduct-nav-sale"
                    role="tabpanel"
                    aria-labelledby="addProduct-nav-sale-tab"
                  >
                    <div className="mt-5">
                      <div className="d-flex flex-wrap">
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="productPriceFrom">
                              حداقل قیمت(تومان):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="productPriceFrom"
                              name="price_from"
                              value={addCommas(addProduct.price_from)}
                              onChange={e => {
                                inputChanged(e);
                                // let value = removeCommas(e.target.value);
                                // try {
                                //   if (isNaN(value))
                                //     throw new Error(
                                //       "لطفا عدد را به درستی وارد نمایید."
                                //     );
                                //   setAddProduct(prev => {
                                //     return {
                                //       ...prev,
                                //       default_price: +value
                                //     };
                                //   });
                                // } catch (ex) {
                                //   toast.error(ex.message);
                                // }
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.price_from == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد قیمت نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="productPriceTo">
                              حداکثر قیمت(تومان):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="productPriceTo"
                              name="price_to"
                              value={addCommas(addProduct.price_to)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.price_to == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد قیمت نباید خالی باشد.
                            </div>
                            <div
                              className={`ms-1 ${
                                validateStatus.checkPrice == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              حداکثر قیمت نمی تواند از حداقل قیمت کمتر باشد
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className="my-2 me-3">
                            <label htmlFor="benefitStore">
                              درصد سود فروشگاه :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="benefitStore"
                              name="Interest_rates"
                              value={addCommas(addProduct.Interest_rates)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.Interest_rates == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد درصد نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="commissionShop">
                              درصد کمیسیون از فروشگاه :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="commissionShop"
                              name="shop_commission"
                              value={addCommas(addProduct.shop_commission)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.shop_commission == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد کمیسیون فروشگاه نباید خالی باشد.
                            </div>
                          </div>
                        </div>

                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="commissionSupplier">
                              درصد کمیسیون از تامین کننده :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="commissionSupplier"
                              name="mainshop_commission"
                              value={addCommas(addProduct.mainshop_commission)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.mainshop_commission == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد کمیسیون تامین کننده نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* محتوا اطلاعات تکمیلی */}
                  <div
                    className="tab-pane fade "
                    id="addProduct-nav-more"
                    role="tabpanel"
                    aria-labelledby="addProduct-nav-more-tab"
                  >
                    <div className="my-3" dir="">
                      <SunEditor
                        setOptions={{
                          height: 250,
                          buttonList: [
                            [],
                            [
                              "undo",
                              "redo",
                              "font",
                              "fontSize",
                              "formatBlock",
                              "bold",
                              "underline",
                              "strike",
                              "fontColor",
                              "textStyle",
                              "removeFormat",
                              "align",
                              "horizontalRule",
                              "list",
                              "lineHeight",
                              "link",
                              "image",
                              "video",
                              "audio",
                              "imageGallery",
                              "fullScreen",
                              "preview"
                            ]
                          ] // Or Array of button list, eg. [['font', 'align'], ['image']]
                        }}
                        // value={addProduct.bodytxt}
                        setContents={addProduct.bodytxt}
                        onChange={content => {
                          console.log(content, "value");
                          console.log(
                            "addProduct.bodytxt ",
                            addProduct.bodytxt.toString()
                          );
                          setAddProduct(prev => {
                            return { ...prev, bodytxt: content.toString() };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* </div> */}
                <div className="text-center">
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={() => {
                      if (validation()) {
                        // let x = await insertHashtags(productTag);
                        // saveData(x);
                        saveData();
                      }
                    }}
                  >
                    ثبت
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductModal;
